export const addExternalScript = ({ src, async = true, integrity, crossOrigin }) =>
  new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.setAttribute('src', src);
    script.async = async;
    if (integrity) script.integrity = integrity;
    if (crossOrigin) script.crossorigin = 'anonymous';

    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject(script.src));
    document.getElementsByTagName('head')[0].appendChild(script);
  });

export const loadOnInteraction = ({ callback }) => {
  let active = true;
  const EVENTS = 'mousemove touchmove click keydown';
  // scroll, resize & orientationchange are excluded as these events are fired during Lighthouse test

  const init = () => {
    if (active) {
      /* Callback */
      callback();
      /* Remove Event Listener */
      EVENTS.split(' ').forEach(e => window.removeEventListener(e, init));
    }
    active = false;
  };

  /* Init */
  EVENTS.split(' ').forEach(e => window.addEventListener(e, init));
};
